import clsx from 'clsx';
import React, { ReactElement, ReactNode, useState } from 'react';

interface ICardProps {
  header?: ReactNode;
  children: ReactNode;
  classes?: string;
}

function Card(props: ICardProps): JSX.Element {

  return (
    <>
      <div className={clsx(`bg-white dark:bg-primary-dark-surface rounded-2xl border border-gray-200 dark:border-primary-dark-border_active overflow-hidden`, props.classes)}>
        {props.header && <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 border-b border-gray-100 dark:border-primary-dark-border_active  mb-4">
          {props.header}
        </div>}

        {props.children}
      </div>
    </>
  );
}

export default Card;
